import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import { type DetailVacanciesTemplate } from '../types';

export const useGetVacancyTemplate = <T = DetailVacanciesTemplate>(
  id: number
) => {
  return useQuery({
    queryKey: [QueryKey.GET_VACANCY_TEMPLATE, id],
    queryFn: () => vacancyApi.getVacanciesTemplate<T>(id),
  });
};
